import React, { useState } from 'react';
import {
    FormGroup,
    ModalBody,
    ModalHeader,
    Input,
    FormText,
} from 'reactstrap';
import './EditEngagementValuesModal.scss';
import Rodal from '../../../../components/Rodal/Rodal';
import ButtonLoader from '../../../../components/Layout/Buttons/ButtonLoader';
import { DropdownList } from 'react-widgets/cjs';
import { ArrowDown } from '../../../../components/arrow-down/arrow-down';
import { CurrencyInput, Form } from '@availity/form';

interface EditEngagementValuesModalProps {
    engagementId: number;
    currentFteDvm: number;
    currentLtmRevenue: number;
    isVisible: boolean;
    setIsVisible: (isVisible: boolean) => void;
    onSave: (fteDvm: number, ltmRevenue: number, reason: string) => void;
    isSaving: boolean;
}

const EditEngagementValuesModal = (props: EditEngagementValuesModalProps) => {
    const [fteDvm, setFteDvm] = useState(props.currentFteDvm);
    const [ltmRevenue, setLtmRevenue] = useState(props.currentLtmRevenue);
    const [reason, setReason] = useState('');
    const [isFteDvmError, setIsFteDvmError] = useState(false);
    const [isLtmRevenueError, setIsLtmRevenueError] = useState(false);
    const [isReasonError, setIsReasonError] = useState(false);

    const getFteDvmsNumberList = () => {
        const fteDvms = [];

        for (let i = 1; i < 50.5; i += 0.5) {
            fteDvms.push({ id: i, value: i.toString() });
        }

        return fteDvms;
    };

    const handleSave = () => {
        let hasErrors = false;

        if (!fteDvm || fteDvm <= 0) {
            setIsFteDvmError(true);
            hasErrors = true;
        } else {
            setIsFteDvmError(false);
        }

        if (!ltmRevenue || ltmRevenue <= 0) {
            setIsLtmRevenueError(true);
            hasErrors = true;
        } else {
            setIsLtmRevenueError(false);
        }

        if (!reason || reason.trim() === '') {
            setIsReasonError(true);
            hasErrors = true;
        } else {
            setIsReasonError(false);
        }

        if (hasErrors) {
            return;
        }

        props.onSave(fteDvm, ltmRevenue, reason.trim());
    };

    return (
        <Rodal
            visible={props.isVisible}
            onClose={() => {
                props.setIsVisible(false);
            }}
            animation={'fade'}
            showMask={false}
            width={750}
            className="edit-engagement-values-modal-rodal"
            center>
            <div className="edit-engagement-values-modal">
                <ModalHeader>Edit Engagement Values</ModalHeader>
                <ModalBody>
                    <FormGroup className="fte-dvm-form-group">
                        <div className="form-field-container">
                            <div className="mobile-label">
                                <label className="copy-name-label">FTE DVMs, at engagement start:</label>
                            </div>
                            <div className="mobile-input">
                                <DropdownList
                                    selectIcon={<ArrowDown />}
                                    className={`dropbox-field div-field-value ${isFteDvmError ? 'av-invalid is-invalid' : ''
                                        }`}
                                    data={getFteDvmsNumberList()}
                                    value={fteDvm}
                                    onChange={(value: any) => {
                                        setFteDvm(value.id);
                                        if (value.id > 0) {
                                            setIsFteDvmError(false);
                                        }
                                    }}
                                    dataKey="id"
                                    textField="value"
                                />
                            </div>
                        </div>
                    </FormGroup>

                    <FormGroup className="ltm-revenue-form-group">
                        <div className="form-field-container">
                            <div className="mobile-label">
                                <label className="copy-name-label">
                                    LTM Revenue, at engagement start:
                                </label>
                            </div>
                            <div className="mobile-input">
                                <Form
                                    onSubmit={() => { }}
                                    initialValues={{
                                        ltmRevenue: ltmRevenue != null ? ltmRevenue.toString() : '',
                                    }}>
                                    <CurrencyInput
                                        name="ltmRevenue"
                                        id="ltmRevenue"
                                        value={ltmRevenue != null ? ltmRevenue.toString() : ''}
                                        allowDecimals={true}
                                        allowNegativeValue={false}
                                        prefix="$"
                                        onValueChanged={(value) => {
                                            const numValue = parseFloat(value) || 0;
                                            setLtmRevenue(numValue);
                                            if (numValue > 0) {
                                                setIsLtmRevenueError(false);
                                            }
                                        }}
                                        className={isLtmRevenueError ? 'av-invalid is-invalid' : ''}
                                    />
                                </Form>
                            </div>
                        </div>
                    </FormGroup>

                    <FormGroup>
                        <label className="copy-name-label reason">Reason:</label>
                        <Input
                            type="textarea"
                            name="reason"
                            id="reason"
                            rows={4}
                            value={reason}
                            onChange={(e: any) => {
                                setReason(e.target.value);
                                if (e.target.value.trim() !== '') {
                                    setIsReasonError(false);
                                }
                            }}
                            className={isReasonError ? 'av-invalid is-invalid' : ''}
                            placeholder="Enter reason for changing engagement values"
                        />
                        {isReasonError && (
                            <FormText color="danger" className="mt-1">
                                Reason is required
                            </FormText>
                        )}
                    </FormGroup>
                    <div className="mt-auto d-flex justify-content-end modal-copy-buttons">
                        <button
                            type="button"
                            className="btn btn-cancel"
                            onClick={() => {
                                props.setIsVisible(false);
                            }}>
                            Cancel
                        </button>
                        <ButtonLoader
                            buttonText={'Save'}
                            disabled={fteDvm <= 0 || ltmRevenue <= 0 || !reason || reason.trim() === ''}
                            isLoading={props.isSaving}
                            onClick={handleSave}
                            className={props.isSaving ? 'btn btn-primary loader-submit' : 'btn btn-primary'}
                            loaderButtonText={undefined}></ButtonLoader>
                    </div>
                </ModalBody>
            </div>
        </Rodal>
    );
};

export default EditEngagementValuesModal;